import { render, staticRenderFns } from "./UIGenderPicker.vue?vue&type=template&id=00d548ee"
import script from "./UIGenderPicker.vue?vue&type=script&lang=ts"
export * from "./UIGenderPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports